import { Component, Input } from '@angular/core';
import { LoadingIconButtonComponent } from '@app-components/common/loading-icon-button/loading-icon-button.component';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuItem } from '@angular/material/menu';

@Component({
  selector: 'app-final-delete-button',
  templateUrl: './final-delete-button.component.html',
  styleUrls: ['./final-delete-button.component.scss'],
  imports: [LoadingIconButtonComponent, MatIcon, TranslateModule, MatMenuItem],
})
export class FinalDeleteButtonComponent {
  @Input() isMenu = false;

  constructor() {}
}
